import axios from "axios";
import { getUserFromLS } from "../utils/getUserFromLS";
import { ICadenceTemplateRead } from "../Types/socialPromptCadenceTemplate";

/** Fetch a single saved cadence template by id. */
export const getSocialPromptCadenceTemplate = async (
  templateId: string
): Promise<ICadenceTemplateRead> => {
  const user = getUserFromLS();
  const URL = `${import.meta.env.VITE_API_BASE_URL}/social-prompt-cadence-templates/${encodeURIComponent(
    templateId
  )}`;

  const response = await axios.get<ICadenceTemplateRead>(URL, {
    headers: {
      Authorization: `Bearer ${user.access_token}`,
    },
  });

  return response.data;
};
